<app-grid-columns-manage [gridColumns]='this.columns'></app-grid-columns-manage>
<app-grid-save-search (saved)='this.onGridSavedSearchModalSaved($event)'></app-grid-save-search>

<div class="gridContainer">
  @if (this.simpleSearch === false && this.showSearch) {
    <div class="searchFiltersContainer">
      <div class="searchToolbarHeader">
        <h3>Advanced Search</h3>
        @if (this.toolbarButtons.length > 0) {
          <div class="toolbar-buttons">
            @for (button of this.toolbarButtons; track button) {
              @if (this.isToolbarButtonVisible(button)) {
                <button
                  [class]="this.getButtonClass(button)"
                  [disabled]="this.isToolbarButtonDisabled(button)"
                  (click)="this.onToolbarButtonClick(button, $event)"
                  [innerHTML]="this.getButtonContent(button)"
                  type='button'
                ></button>
              }
            }
          </div>
        }
        <div class="quickSearchActions">
          <button class='btn btn-primary btn-sm' (click)='this.simpleSearch = true'><i class="fas fa-search"></i> Quick Search</button>
          <div class="dropdown">
            <button class="btn btn-secondary btn-sm dropdown-toggle" type="button" id="dropdownMenuButtonAdvanced" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
              <i class="fas fa-cog"></i>
            </button>
            <div class="dropdown-menu dropdown-menu-right" aria-labelledby="dropdownMenuButtonAdvanced">
              <a class="dropdown-item" (click)='this.exportToCSV()'>Export to CSV</a>
              <a class='dropdown-item' (click)='this.openModal("gridManageColumns")'>Manage Columns</a>
            </div>
          </div>
        </div>
      </div>

      <div class="searchSection">
        <h4>Saved Searches</h4>
        <div class="savedSearchRow">
          <select class='form-control savedSearchSelect' (change)='this.selectedSavedSearchId = +$event.target.value'>
            <option value='-1'>Select a saved search</option>
            @for (search of this.savedSearches.items; track search) {
              <option [value]='search.id'>{{ search.name }}</option>
            }
          </select>
          <button class='btn btn-primary btn-sm' (click)='loadSearch()'>Load Search</button>
          <button class='btn btn-success btn-sm' (click)='saveSearch()'>Save Search</button>
        </div>
      </div>

      <div class="searchSection">
        @for (filterRecord of this.selectedFilters; track filterRecord; let i = $index) {
          <div class='filterRow'>
            <select class="form-control" (change)='onFieldSelected($event, filterRecord)'>
              <option value="-1">Select a field</option>
              @for (filter of this.searchFilters; track filter) {
                <option
                  [value]="filter.field"
                  [selected]='filter.field === filterRecord.field'
                  >
                  {{ filter.label }}</option
                  >
                }
              </select>
              <select class="form-control" (change)='onConditionSelected($event, filterRecord)'>
                <option [selected]='filterRecord.condition === "-1"' value="-1">Select a condition</option>
                <option [selected]='filterRecord.condition === "eq"' value="eq">Equals</option>
                <option [selected]='filterRecord.condition === "ne"' value="ne">Not equal to</option>
                <option [selected]='filterRecord.condition === "gt"' value="gt">Greater than</option>
                <option [selected]='filterRecord.condition === "lt"' value="lt">Less than</option>
                <option [selected]='filterRecord.condition === "starts"' value="starts">Starts with</option>
                <option [selected]='filterRecord.condition === "ends"' value="ends">Ends with</option>
                <option [selected]='filterRecord.condition === "cont"' value="cont">Contains</option>
              </select>
              <input [type]="this.getSearchFilterType(filterRecord.field)" [(ngModel)]='filterRecord.value' (ngModelChange)='onValueChanged()' class="form-control" />
              <button class='btn btn-danger filterRowBtn' type='button' (click)='deleteSelectedFilter(i)' title='Remove filter'><i class="fas fa-times"></i></button>
          </div>
        }
        <div class="filterRow">
            <select class="form-control" (change)='onFieldSelected($event, null)'>
              <option value="-1">Select a field</option>
              @for (filter of this.searchFilters; track filter) {
                <option
                  [value]="filter.field"
                  [selected]='this.newSearchFilter.field === filter.field'
                  >
                  {{ filter.label }}</option
                  >
                }
              </select>
              <select class="form-control" (change)='onConditionSelected($event, null)'>
                <option [selected]='this.newSearchFilter.condition === "-1"' value="-1">Select a condition</option>
                <option [selected]='this.newSearchFilter.condition === "eq"' value="eq">Equals</option>
                <option [selected]='this.newSearchFilter.condition === "ne"' value="ne">Not equal to</option>
                <option [selected]='this.newSearchFilter.condition === "gt"' value="gt">Greater than</option>
                <option [selected]='this.newSearchFilter.condition === "lt"' value="lt">Less than</option>
                <option [selected]='this.newSearchFilter.condition === "starts"' value="starts">Starts with</option>
                <option [selected]='this.newSearchFilter.condition === "ends"' value="ends">Ends with</option>
                <option [selected]='this.newSearchFilter.condition === "cont"' value="cont">Contains</option>
              </select>
              <input [type]="this.currentSearchFilterType" [(ngModel)]='this.newSearchFilter.value' class="form-control" />
              <button type='button' class='btn btn-success filterRowBtn' (click)='addSelectedFilter($event)' title='Add filter'><i class="fas fa-plus"></i></button>
        </div>
      </div>
    </div>
  }

  @if (this.simpleSearch === true && this.showSearch) {
    <div class="searchFiltersContainer">
      <div class="quickSearchBar">
        <span class="quickSearchLabel">Quick Search</span>
        @if (this.toolbarButtons.length > 0) {
          <div class="toolbar-buttons">
            @for (button of this.toolbarButtons; track button) {
              @if (this.isToolbarButtonVisible(button)) {
                <button
                  [class]="this.getButtonClass(button)"
                  [disabled]="this.isToolbarButtonDisabled(button)"
                  (click)="this.onToolbarButtonClick(button, $event)"
                  [innerHTML]="this.getButtonContent(button)"
                  type='button'
                ></button>
              }
            }
          </div>
        }
        <div class="quickSearchInputGroup">
          <i class="fas fa-search"></i>
          <input
            type="text"
            (keyup)="this.onSearchKeyUp($event)"
            [(ngModel)]="this.search"
            placeholder="Search..."
            />
        </div>
        <div class="quickSearchActions">
          <button class='btn btn-primary btn-sm' (click)='this.simpleSearch = false'>Advanced Search</button>
          <div class="dropdown">
            <button class="btn btn-secondary btn-sm dropdown-toggle" type="button" id="dropdownMenuButtonQuick" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
              <i class="fas fa-cog"></i>
            </button>
            <div class="dropdown-menu dropdown-menu-right" aria-labelledby="dropdownMenuButtonQuick">
              <a class="dropdown-item" (click)='this.exportToCSV()'>Export to CSV</a>
              <a class='dropdown-item' (click)='this.openModal("gridManageColumns")'>Manage Columns</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  }

  @if (this.showDatePicker) {
    <div class="dateToolbar">
      @if (this.isDatePickerVisible) {
        <bs-datepicker-inline (bsValueChange)='this.onDateSelected($event)' [bsValue]='this.getFormatDate(this.displayDate)' class='datePicker'></bs-datepicker-inline>
      }
      <div class="btn-group">
        <button class='btn btn-primary'(click)='this.dateChange("yesterday")'><i class="fas fa-angle-double-left"></i> {{this.yesterdayDate}}</button>
        <button class='btn btn-success' (click)='this.isDatePickerVisible = !this.isDatePickerVisible'><i class="fas fa-calendar"></i> {{this.getFormatDate(this.displayDate)}}</button>
        <button class='btn btn-primary'(click)='this.dateChange("tomorrow")'>{{this.tomorrowDate}} <i class="fas fa-angle-double-right"></i></button>
      </div>
    </div>
  }

  <div class="gridTableCard">
  @if (!this.showSearch) {
    <div class="gridToolbar">
      @if (this.toolbarButtons.length > 0) {
        <div class="toolbar-buttons">
          @for (button of this.toolbarButtons; track button) {
            @if (this.isToolbarButtonVisible(button)) {
              <button
                [class]="this.getButtonClass(button)"
                [disabled]="this.isToolbarButtonDisabled(button)"
                (click)="this.onToolbarButtonClick(button, $event)"
                [innerHTML]="this.getButtonContent(button)"
                type='button'
              ></button>
            }
          }
        </div>
      }
      <div class="dropdown">
        <button class="btn btn-secondary dropdown-toggle" type="button" id="dropdownMenuButtonNoSearch" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
          <i class="fas fa-cog"></i>
        </button>
        <div class="dropdown-menu dropdown-menu-right" aria-labelledby="dropdownMenuButtonNoSearch">
          <a class="dropdown-item" (click)='this.exportToCSV()'>Export to CSV</a>
          <a class='dropdown-item' (click)='this.openModal("gridManageColumns")'>Manage Columns</a>
        </div>
      </div>
    </div>
  }

      <table class="table">
        <thead  class="thead-light">
          <tr>
            @if (this.checkboxSelector) {
              <th>
                <input type='checkbox' (click)='selectAll($event)'/>
              </th>
            }
            @if (this.radioSelector) {
              <th>
                &nbsp;
              </th>
            }
            @for (column of this.getActiveColumns(); track column) {
              <th [style.color]='this.textColor' [class.inverse]='this.inverse'>
                <a href="#" (click)="this.onColumnHeaderClicked(column); $event.preventDefault();"
                  >{{ this.getLabelForColumn(column) }}
                  {{ this.getColumnSortMarker(column) }}</a
                  >
                </th>
              }

              @if (this.buttons.length > 0) {
                <th>&nbsp;</th>
              }
            </tr>
          </thead>
          <tbody>
            @for (record of this.records; track record) {
              <tr [attr.title]='this.getHoverText(record)'>
                @if (this.radioSelector) {
                  <td [style.background-color]='this.getBackground(record)'>
                    <input [checked]='this.defaultRadioValue === record.id' type='radio' name='radio_group_grid[]' (click)='this.onRadioClicked(record)' [value]='record.id'/>
                  </td>
                }
                @if (this.checkboxSelector) {
                  <td [style.background-color]='this.getBackground(record)'>
                    <input type='checkbox' name='checkbox_group_grid[]' [checked]='isChecked(record.id)' (click)='this.onCheckboxClicked($event,record)' [value]='record.id'/>
                  </td>
                }
                @for (column of this.getActiveColumns(); track column) {
                  <td [style.color]='this.textColor' class="px-3 py-1" [innerHTML]=' this.getColumnValueForField(column, record)' [style.background-color]='this.getBackground(record)'>
                  </td>
                }
                @if (this.buttons.length > 0) {
                  <td class="px-0 py-0" style='text-align: center;' [style.background-color]='this.getBackground(record)'>
                    @for (button of this.buttons; track button) {
                      <button
                        [class]="this.getButtonClass(button)"
                        [disabled]='this.isButtonDisabled(button, record)'
                        (click)="this.buttonClicked(button, record, $event)"
                        [innerHTML]="this.getButtonContent(button)"
                        [hidden]='!this.isButtonVisible(button, record)'
                        type='button'
                      ></button>
                    }
                  </td>
                }
              </tr>
            }
            @if (this.records.length === 0) {
              <tr class="gridEmptyRow">
                <td colspan="80">
                  <div class="gridEmptyState">
                    <i class="fas fa-inbox"></i>
                    <p>No records found.</p>
                  </div>
                </td>
              </tr>
            }
          </tbody>
          <tfoot>
            <tr>
              <td colspan='80'>
                <div class='gridStatusLine'>
                  <div class="pagesLine">
                    {{ this.getOffsetStart() }}-{{ this.getOffsetEnd() }} of
                    {{ this.getTotalRecords() }} item(s) Page: <input type='form-control' [(ngModel)]="this.newPage" (keyup)='this.onPaginationPageClicked(+this.newPage)'/>
                  </div>
                  <div class="amountLine">
                    Result(s) per page
                    <select
                      class="resultsPerPageSelect form-control"
                      (change)="onPaginationAmountChanged($event)"
                      >
                      <option [selected]="this.amount === 5" value="5">5</option>
                      <option [selected]="this.amount === 10" value="10">10</option>
                      <option [selected]="this.amount === 20" value="20">20</option>
                      <option [selected]="this.amount === 50" value="50">50</option>
                      <option [selected]="this.amount === 100" value="100">100</option>
                    </select>
                  </div>
                </div>

              </td>
            </tr>

          </tfoot>
        </table>



        <div class="gridPagination">
          <ul>
            @if (this.isPrevActive()) {
              <li>
                <button
                  class="btn btn-secondary"
                  type="button"
                  name="button"
                  (click)="onPaginationPageClicked(this.getCurrentPage() - 1)"
                  >
                  &lt;
                </button>
              </li>
            }

            @if (this.paginationService.getTotalPages() <= 30) {
              @for (page of this.getPagesArray(); track page) {
                <li>
                  <button
                    class="btn btn-secondary"
                    type="button"
                    name="button"
                    (click)="onPaginationPageClicked(page)"
                    [class.active]="page === this.getCurrentPage()"
                    >
                    {{ page }}
                  </button>
                </li>
              }
            }

            @if (this.paginationService.getTotalPages() > 30) {
              @for (page of this.paginationService.getShortPagesRange(this.paginationService.getPage(), this.paginationService.getTotalPages()); track page) {
                @if (page !== "...") {
                  <li>
                    <button
                      class="btn btn-secondary"
                      type="button"
                      name="button"
                      (click)="onPaginationPageClicked(page)"
                      [class.active]="page === this.getCurrentPage()"
                      >
                      {{ page }}
                    </button>
                  </li>
                }
                @if (page === "...") {
                  <span>...</span>
                }
              }
            }
            @if (this.isNextActive()) {
              <li>
                <button
                  class="btn btn-secondary"
                  type="button"
                  name="button"
                  (click)="onPaginationPageClicked(this.getCurrentPage() + 1)"
                  >
                  &gt;
                </button>
              </li>
            }

          </ul>
        </div>
  </div>
